/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Seo_Home_Og_Image1Inputs */

const vi_sitesettings_seo_home_og_image1 = /** @type {(inputs: Sitesettings_Seo_Home_Og_Image1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh chia sẻ trang chủ`)
};

/**

* @param {Sitesettings_Seo_Home_Og_Image1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_seo_home_og_image1 = /** @type {((inputs?: Sitesettings_Seo_Home_Og_Image1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Seo_Home_Og_Image1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_seo_home_og_image1(inputs)
});
export { sitesettings_seo_home_og_image1 as "siteSettings_seo_home_og_image" }